import { backupApi } from '../api/backupApi'

export const getBackupFile = async (fileId: string) => {
  try {
    const response = await backupApi.downloadFile(fileId)
    return response.data
  } catch (error) {
    console.error(`Error fetching backup file: `, error)
    throw error
  }
}
